import { createContext } from "react";

/**
 * Context props for the SideNav component
 */
export type SideNavContextProps = {
  /**
   * List of navigable elements in the side navigation
   */
  links: NodeListOf<Element> | undefined;
  /**
   * Function to recalculate the list of navigable links
   */
  reCalculateLinks: () => void;
  /**
   * Set of currently active link IDs
   */
  activeIds: Set<string>;
  /**
   * Function to add an ID to the active set
   */
  addActiveId: (id: string) => void;
  /**
   * Function to remove an ID from the active set
   */
  removeActiveId: (id: string) => void;
};

export const SideNavContext = createContext<SideNavContextProps | null>(null);
